import React from 'react';
import { RenderModule } from 'holocron';

export const AxpFooterModule = {
  name: 'axp-footer',
  props: {
    hideSocialSection: true,
    hideChangeCountrySection: true,
    hideLastLoginSection: true,
    hideLegalSection: false,
    hideLogoSection: false,
  },
};

const Footer = () => (
  <div>
    <RenderModule
      moduleName={AxpFooterModule.name}
      props={AxpFooterModule.props}
    >
      {' '}
    </RenderModule>
  </div>
);

export default Footer;
